import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { makeStyles, Snackbar, Typography } from '@material-ui/core';
import React from 'react';
import { COLORS } from '../../../constants/colors';
import { NOTIFICATION } from '../../../constants/props';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '1rem',
    borderRadius: '0.3125rem',
    padding: '.5rem 1rem',
    minWidth: '20rem',
    backgroundColor: ({ type }) => COLORS[type],
    fontSize: '1rem',
  },
  message: {
    flexGrow: '1',
  },
  close: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
});

const Notification = ({ id, type, message, timeout, onClose }) => {
  const classes = useStyles({ type });

  function handleClose() {
    onClose(id);
  }

  return (
    <Snackbar
      key={id}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      autoHideDuration={timeout}
      open={true}
      onClose={handleClose}
    >
      <div className={classes.container}>
        <Typography className={classes.message} variant="body1">
          {message}
        </Typography>
        <FontAwesomeIcon
          className={classes.close}
          icon={faTimes}
          onClick={handleClose}
        />
      </div>
    </Snackbar>
  );
};

Notification.defaultProps = {
  timeout: 3000,
};

Notification.propTypes = {
  NOTIFICATION,
};

export default Notification;
